import { Component, OnInit, ElementRef, ViewChild, AfterViewChecked, HostListener, AfterViewInit } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { ContentAuthoringService } from "../../services/content-authoring.service";
import { AssessmentService } from "../../services/assessment.service";
import { NgbModal, ModalDismissReasons, NgbPaginationConfig, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { CapsuleValidator } from '../../services/capsule.validator';
import { ToastrService } from 'ngx-toastr';
import { CdkDragDrop, moveItemInArray, CdkDrag } from '@angular/cdk/drag-drop';
//import {NgxImageCompressService} from 'ngx-image-compress';
//import { ScrollToBottomDirective } from '../../services/scroll-to-bottom.directive';

@Component({
  selector: 'app-authoring-create',
  templateUrl: './authoring-create.component.html',
  styleUrls: ['./authoring-create.component.scss']
})
export class AuthoringCreateComponent implements OnInit {

  // @ViewChild(ScrollToBottomDirective)
  //  @HostListener("window:scroll", ["$event"])
  //  onWindowScroll() {
  //  //In chrome and some browser scroll is given to body tag
  //  let pos = (document.documentElement.scrollTop || document.body.scrollTop) + document.documentElement.offsetHeight;
  //  let max = document.documentElement.scrollHeight;
  //  // pos/max will give you the distance between scroll bottom and and bottom of screen in percentage.
  //   if(pos == max )   {
  //   //Do your action here
  //   }
  //  }
  submitted = false; progress: number = 0; tab: any; reorders: any = []; contentArray: any = []; submittedOrder = false;
  image: any = []; video: any = []; text: any = []; urls: any = [];
  imageSrc: any = []; fileName: any = []; fileType: any = [];
  errorInfo: { isError: boolean, errorMsg: string } = { isError: false, errorMsg: '' };
  imageError: any = []; videoError: any = [];
  countformArr: number = 0; data = {}; adminData: any;
  moveToAddModule: boolean = false;
  tempStoreFormData: any = null; activeCanMod: boolean = true;
  assessment_id: any = null;
  closeResult: any = ''; page: string = '';
  succesDelAssessment: boolean = false;
  activeDleMod: boolean = true;
  capsuleId: any = ''; course: any = 'capsule'; errorMsgImgSize: any = '';

  constructor(private _fb: FormBuilder,
    // private scroll: ScrollToBottomDirective,
    private el: ElementRef,
    private route: ActivatedRoute,
    private router: Router,
    private contentAuthoringApi: ContentAuthoringService,
    private AssessmentServiceApi: AssessmentService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal, private toastr: ToastrService) {
    if (localStorage.getItem('adminData') == '' || localStorage.getItem('adminData') == null) {
      this.router.navigateByUrl('/admin-login');
    }
  }
  contentAuthForm = new FormGroup({});
  get f() { return this.contentAuthForm.controls; }
  // contentOrderForm = new FormGroup({});
  // get f1() { return this.contentOrderForm.controls; }
  get formArr() {
    return this.contentAuthForm.get('contentCapsuleMedia') as FormArray;
  }
  initItemText() {
    return this._fb.group({
      media_title: [''],
      media_content: ['', [Validators.required]],
      media_path: [''],
      media_name: [''],
      media_type: ['1'],
      media_img_video_title:[''],
      isBase64: ['0'],
      content_capsule_id: [null],
      content_capsule_media_id: [null]
    });
  }
  initItemVideo() {
    return this._fb.group({
      media_title: [''],
      media_content: [''],
      //media_path: ['', [Validators.required]],
      media_path: [''],
      media_name: [''],
      media_type: ['3'],
      media_img_video_title:[''],
      isBase64: ['0'],
      content_capsule_id: [null],
      content_capsule_media_id: [null]
    });
  }
  initItemImage() {
    return this._fb.group({
      media_title: [''],
      media_content: [''],
      // media_path: ['', [Validators.required]],
      media_path: [''],
      media_name: [''],
      media_type: ['2'],
      media_img_video_title:[''],
      isBase64: ['0'],
      content_capsule_id: [null],
      content_capsule_media_id: [null]
    });
  }
  addNewText() {
    this.text.push(1);
    this.video.push(0);
    this.image.push(0);
    this.formArr.push(this.initItemText());
    this.countformArrlength();
  }
  addNewVideo() {
    this.text.push(0);
    this.video.push(1);
    this.image.push(0);
    this.formArr.push(this.initItemVideo());
    this.countformArrlength();
  }
  addNewImage() {
    this.text.push(0);
    this.video.push(0);
    this.image.push(1);
    this.formArr.push(this.initItemImage());
    this.countformArrlength();
  }
  /******delete text from content capsule */
  deleteRow(i: number) {
    this.formArr.removeAt(i);
    this.imageSrc.splice(i, 1);
    this.fileName.splice(i, 1);
    this.fileType.splice(i, 1);
    this.text.splice(i, 1);
    this.video.splice(i, 1);
    this.image.splice(i, 1);
    this.countformArrlength();
  }
  /****select image for content capsule */
  onFileChange(event: any, i: any, types: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.fileType[i] = file.type;
      if (types == 'image') {
        if (file.size / 1024 > 5120) {
          this.errorInfo.errorMsg = 'Size should be less than 5MB';
          this.errorMsgImgSize = 'Size should be less than 5MB';
          document.getElementById('errorImg')?.click();
          return;
        }
        if (this.fileType[i].match(/image\/(png|jpeg|jpg)/) == null) {
          this.errorInfo.errorMsg = 'Only png, jpg, jpeg images are allowed';
          this.errorMsgImgSize = 'Only png, jpg, jpeg images are allowed';
          document.getElementById('errorImg')?.click();
          return;
        }
      } else {
        if (file.size / 1024 > 204800) {
          this.errorInfo.errorMsg = 'Size should be less than 200MB';
          this.errorMsgImgSize = 'Size should be less than 200MB';
          document.getElementById('errorImg')?.click();
          return;
        }
        if (this.fileType[i].match(/video\/(mp4)/) == null) {
          this.errorInfo.errorMsg = 'Only mp4 are allowed';
          this.errorMsgImgSize = 'Only mp4 are allowed';
          document.getElementById('errorImg')?.click();
          return;
        }
      }
      reader.readAsDataURL(file);
      reader.onload = (event: any) => {
        this.fileName[i] = file.name;
        this.imageSrc[i] = reader.result as string;
        this.formArr.at(i).patchValue({ "media_path": reader.result });
        this.formArr.at(i).patchValue({ "isBase64": '1' });
        this.formArr.at(i).patchValue({ "media_name": file.name });
      };
    }
  }
  saveChangedValue(){
    this.saveContentAuth('2', 5)
  }
  /****save content authoring function */
  saveContentAuth(capsules_status: any, tabIndex: number) {
    this.contentAuthForm.markAllAsTouched();
    this.spinner.show();
    this.submitted = true;
    this.contentAuthForm.patchValue({ capsules_status: capsules_status });
    this.contentAuthForm.patchValue({ assessment_id: this.assessment_id });
    if (this.contentAuthForm.invalid || this.countformArr<1) {
      this.spinner.hide();
      return;
    }
    // console.log(this.contentAuthForm.value);return;
    if (this.capsuleId != '' && this.capsuleId != null) {
      this.page = 'edit';
      delete this.contentAuthForm.value['created_by'];
      this.contentAuthForm.value['updated_by'] = this.adminData.user_id;
    } else {
      this.page = 'create';
    }
    this.contentAuthoringApi.upload(this.contentAuthForm.value, this.page).subscribe(
      (data) => {
        if (data.status == 201 || data.status == 200) {
          this.capsuleId= data.content_capsule_id
          this.contentAuthForm.patchValue({ content_capsule_id: this.capsuleId });
          this.spinner.hide();
          //this.progress = 0;
          if (tabIndex == 0) {
            this.router.navigate(['/content-auth-success'], { queryParams: { id: data.content_capsule_id } });
          } else if (tabIndex == 2) {
            this.router.navigate(['/authoring_list'], { queryParams: { tab: tabIndex } });
          }else if (tabIndex == 5){

          }
           else {
            this.router.navigate(['/authoring_view'], { queryParams: { id: data.content_capsule_id, tab: tabIndex } });
          }
        } else {
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'Something went wrong.'
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }
  countformArrlength() {
    if (this.formArr) {
      this.countformArr = this.formArr.length;
    }
  }
  /********reset capsule ****/
  reseContentAuthForm() {
    document.getElementById('resetId')?.click();
    this.contentAuthForm.reset();
    this.imageSrc = []; this.fileName = []; this.fileType = [];
  }
  /*****remove img of content */
  removeImage(i: number) {
    this.imageSrc[i] = '';
    this.fileName[i] = '';
    this.fileType[i] = '';
  }
  /******add assessment in content capsule */
  addAssesment() {
    this.tempStoreFormData = this.contentAuthForm.value;
    this.contentAuthForm.reset();
    this.moveToAddModule = true;
  }
  editAssesment() {
    if (this.assessment_id) {
      this.moveToAddModule = true;
    }
  }
  /******delete assesment */
  deleteAssessment(assessment_id: any) {
    this.AssessmentServiceApi.dltassessment(assessment_id, this.capsuleId).subscribe(
      data => {
        // console.log(data);
        if (data.status = 200) {
          document.getElementById('cancelId')?.click();
          this.assessment_id = '';
          //this.succesDelAssessment = true;
          this.activeDleMod = false;
          //localStorage.removeItem('formDataVal');
        }
      }, error => {
        alert(error);
      });
  }
  private getDismissReason(reason: any): string {
    this.succesDelAssessment = false;
    this.activeDleMod = true;
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  open(content: any) {
    //console.log(this.imageSrc);
    //console.log(this.fileName);
    //console.log(this.fileType);
   

    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  /**cancel capsule and redirect on listing **/
  cancleCapsule() {
    /****close cancel popup */
    document.getElementById('cancelId')?.click();
    //this.router.navigate(['./authoring_list']);
    this.router.navigate(['/authoring_list'], { queryParams: { tab: this.tab } });
  }
  retFromAddAss(evt: any) {
    //console.log(evt);
    this.moveToAddModule = false;

    setTimeout(() => {
      this.contentAuthForm.patchValue(this.tempStoreFormData);
    }, 0);
    if (evt.status == true) {
      this.assessment_id = evt.assessment_id;
    }
  }
  /******log out admin */
  logout() {
    // localStorage.clear();
    localStorage.removeItem('adminLoginPass');
    localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
  getContentAuthDetails(content_capsule_id: any) {
    this.spinner.show();
    this.contentAuthoringApi.getContentAuthDetails(content_capsule_id).subscribe(
      (data) => {
        // console.log(data.data.contentCapsuleMedia);
        if (data.data && data.data.contentCapsuleMedia) {
          this.capsuleId = data.data.content_capsule_id;
          let arr: Array<any> = data.data.contentCapsuleMedia;
          for (const i in arr) {
            if (arr[i].media_type == 1) {
              this.imageSrc[i] = '';
              this.fileName[i] = '';
              this.addNewText();
            }
            if (arr[i].media_type == 2) {
              this.imageSrc[i] = arr[i].media_path as string;
              this.fileName[i] = arr[i].media_name as string;
              this.addNewImage();
            }
            if (arr[i].media_type == 3) {
              this.imageSrc[i] = arr[i].media_path as string;
              this.fileName[i] = arr[i].media_name as string;
              this.addNewVideo();
            }
          }
          if (data.data.assessment_id != '') {
            this.assessment_id = data.data.assessment_id;
          }
          this.contentAuthForm.patchValue(data.data);
        }
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }
  /************ convert image, video url in base64  *****/
  // toDataURL(src: any, callback: any) {
  //   let xhttp = new XMLHttpRequest();
  //   xhttp.onload = function () {
  //     let fileReader = new FileReader();
  //     fileReader.onloadend = function () {
  //       callback(fileReader.result);
  //     }
  //     fileReader.readAsDataURL(xhttp.response);
  //   }
  //   xhttp.responseType = 'blob';
  //   xhttp.open('GET', src, true);
  //   xhttp.send();
  // }

  ngOnInit() {
    /********get query parameters */
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.countformArrlength();
    this.contentAuthForm = this._fb.group({
      capsule_name: ['', [Validators.required, CapsuleValidator.cannotContainSpace]],
      capsules_status: [''],
      assessment_id: [''],
      created_by: [this.adminData.user_id],
      content_capsule_id: [null],
      contentCapsuleMedia: this._fb.array([]) //this.initItemMore()
      // scrollToFirstInvalidControl();
    });
    // window.scrollTo(0,document.body.scrollHeight);

    // this.contentOrderForm = this._fb.group({
    //   order: this._fb.array([this.initItemMore()])
    // });
    this.route.queryParams.subscribe(queryParams => {
      this.capsuleId = queryParams['id'];
      this.tab = queryParams['tab'];
      if (this.capsuleId != '' && this.capsuleId != null) {
        this.getContentAuthDetails(this.capsuleId);

      }
      if( this.tab == 2){
        setTimeout(() => {
          this.goToBottom()
        }, 3000);
      }
    });
  }
  goToBottom() {
    window.scrollTo(0, document.body.scrollHeight);
  }
  // ngAfterViewChecked() {        
  // //  this.scrollToBottom();        
  //  } 

  //  scrollToBottom(): void {
  //      try {
  //          this.el.nativeElement.scrollTop = this.el.nativeElement.scrollHeight;
  //      } catch(err) { }
  //  }
  // initItemMore(): FormGroup {
  //   return this._fb.group({
  //     capsule_id: [''],
  //     capsules_reorder: ['', [Validators.required, Validators.pattern("^[0-9]*$")]]
  //   });
  // }
  get questionsGetter(): FormArray {
    return this.contentAuthForm.get('contentCapsuleMedia') as FormArray;
  }

  addNewTexts(index: any, data: any) {
    this.formArr.at(index).patchValue({
      "media_title": data['media_title'], "media_content": data['media_content'], "media_path": data['media_path'],
      "media_type": data['media_type'], "content_capsule_id": data['content_capsule_id'], "media_name": data['media_name']
    });
  }
  addNewVideos(index: any, data: any) {
    this.formArr.at(index).patchValue({
      "media_title": data['media_title'], "media_content": data['media_content'], "media_path": data['media_path'],
      "media_type": data['media_type'], "content_capsule_id": data['content_capsule_id'], "media_name": data['media_name']
    });
  }
  addNewImages(index: any, data: any) {
    this.formArr.at(index).patchValue({
      "media_title": data['media_title'], "media_content": data['media_content'], "media_path": data['media_path'],
      "media_type": data['media_type'], "content_capsule_id": data['content_capsule_id'], "media_name": data['media_name']
    });
  }
  /********drag and drop functionality */
  drop(event: any) {
    const from = event.previousIndex;
    const to = event.currentIndex;
    const dataFrom = this.contentAuthForm.value.contentCapsuleMedia[from]
    const dataTo = this.contentAuthForm.value.contentCapsuleMedia[to]
    const textFrom = this.text[from];
    const textTo = this.text[to];
    const imgFrom = this.image[from];
    const imgTo = this.image[to];
    const videoFrom = this.video[from];
    const videoTo = this.video[to];
    const imageSrcFrom = this.imageSrc[from];
    const fileNameFrom = this.fileName[from];
    const fileTypeFrom = this.fileType[from];
    const imageSrcTo = this.imageSrc[to];
    const fileNameTo = this.fileName[to];
    const fileTypeTo = this.fileType[to];

    if (textFrom == 1) {
      this.text[to] = 1;
      this.video[to] = 0;
      this.image[to] = 0;
      this.addNewTexts(to, dataFrom);
      this.imageSrc[to] = '';
      this.fileName[to] = '';
      this.fileType[to] = '';

    }
    if (imgFrom == 1) {
      this.text[to] = 0;
      this.video[to] = 0;
      this.image[to] = 1;
      this.addNewImages(to, dataFrom);
      this.imageSrc[to] = imageSrcFrom;
      this.fileName[to] = fileNameFrom;
      this.fileType[to] = fileTypeFrom;

    }
    if (videoFrom == 1) {
      this.text[to] = 0;
      this.video[to] = 1;
      this.image[to] = 0;
      this.addNewVideos(to, dataFrom);
      this.imageSrc[to] = imageSrcFrom;
      this.fileName[to] = fileNameFrom;
      this.fileType[to] = fileTypeFrom;

    }
    if (textTo == 1) {
      this.text[from] = 1;
      this.video[from] = 0;
      this.image[from] = 0;
      this.addNewTexts(from, dataTo);
      this.imageSrc[from] = '';
      this.fileName[from] = '';
      this.fileType[from] = '';

    };
    if (imgTo == 1) {
      this.text[from] = 0;
      this.video[from] = 0;
      this.image[from] = 1;
      this.addNewImages(from, dataTo);
      this.imageSrc[from] = imageSrcTo;
      this.fileName[from] = fileNameTo;
      this.fileType[from] = fileTypeTo;

    };
    if (videoTo == 1) {
      this.text[from] = 0;
      this.video[from] = 1;
      this.image[from] = 0;
      this.addNewVideos(from, dataTo);
      this.imageSrc[from] = imageSrcTo;
      this.fileName[from] = fileNameTo;
      this.fileType[from] = fileTypeTo;
    };
  }

  /** Clamps a number between zero and a maximum. */
  clamp(value: number, max: number): number {
    return Math.max(0, Math.min(max, value));
  }
  scrollToFirstInvalidControl() {
    //window.scrollTo(0, document.body.scrollHeight);
    // const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
    //   "form .ng-invalid"
    // );

    // // firstInvalidControl.focus(); //without smooth behavior
    // window.scroll({
    //   top: this.getTopOffset(firstInvalidControl),
    //   left: 0,
    //   behavior: "smooth"
    // });

  }
  // private getTopOffset(controlEl: HTMLElement): number {
  //   const labelOffset = 50;
  //   return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  // }
  //   window.onscroll = function(ev) {
  //     if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
  //         alert("you're at the bottom of the page");
  //     }
  // };
}
